module.exports = __webpack_public_path__ + "static/img/pro-7-3.b4fbe93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/pro-7-3.png
// module id = RYob
// module chunks = 0